var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showing)?_c('div',{staticClass:"qf-loading-spinner"},[_c('ons-progress-circular',{attrs:{"indeterminate":""}}),_vm._v(" "),_c('span',{staticClass:"qf-loading-text"},[_vm._v(_vm._s(_vm.message))])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }